import axios from 'axios'

//import apUrl from  '../../public/api_properties'
//import navigation from '../../_nav';
//const API_URL = 'http://localhost:8080'
//const API_URL = 'http://api.exploreit.pl'

const DEV_API_URL = 'http://localhost:8080/invo-bot-api'
const PROD_API_URL = 'https://api.invosystem.com'

//const API_URL = DEV_API_URL;
const API_URL = PROD_API_URL;

class APIService {
    config = {
        headers: {
            authorization: localStorage.getItem("token"),
        }
    }

    getQualityDepartmentList(filterData){
        return axios.post(`${API_URL}/order/qualitychecklist/`,filterData, this.config)
    }

    addOrder(data){
        return axios.put(`${API_URL}/order/add`, data, this.config)
    }

    addOrder2(formData) {
        return axios.put(`${API_URL}/order/add2`, formData, this.config)
    }

    addOrder3(formData) {
        return axios.put(`${API_URL}/order/add3`, formData, this.config)
    }

    executeJwtAuthenticationService(username, password){
        return axios.post(`${API_URL}/authenticate`, {
            username,
            password
        })
    }

    findRecordDetailsById(recId){
        console.log(recId);
        return axios.post(API_URL+`/order/leaddetails`,{
            pk:recId
        },this.config)
    }

    getOrderHistory(or_pk){
        return axios.post(API_URL+`/order/orderhistory`,{
            "or_pk":or_pk
        },this.config)
    }

    statGetCurrentAndEstimation(){
        return axios.post(API_URL+`/order/getCurrentAndEstimation`,{
        },this.config)
    }

    findRecordsByStatusService(status) {
        console.log(status);
        return axios.post(API_URL+`/order/findrecordbystatus`,{
            statuss:status
        },this.config)
    }

    getAgentOrderStatisticLast(number) {
        //alert(this.config.headers.authorization)
        return axios.post(API_URL+`/order/getAgentOrderStatistic`,{
            "minus_days":number
        },this.config)
    }

    findCampaignList() {
        return axios.get(API_URL+`/cc/campaigns`, this.config)
    }

    /*logInCampaign(selectedCampaign) {
        return axios.put(API_URL+`/cc/campaigns/login/`+selectedCampaign, {}, this.config)
    }*/

    logInCampaign(selectedCampaign) {
        return axios.put(API_URL+`/cc/campaigns/loginold/`+selectedCampaign, {}, this.config)
    }

    logOutCampaign(selectedCampaign){
        return axios.delete(API_URL+`/cc/campaigns/logoff/`+selectedCampaign, this.config)
    }

    getRecordByCampaign(selectedCampaign){
        return axios.get(API_URL+`/cc/campaigns/record/`+selectedCampaign, this.config)
    }

    getCurrentState(username) {
        return axios.get(API_URL+'/cc/user/currentstate/',this.config)
    }

    getBreakList(selectedCampaign) {
        return axios.get(API_URL+`/cc/campaigns/breaklist/`+selectedCampaign, this.config)
    }
    pauseCampaign(selectedCampaign, breakPk){
        return axios.put(API_URL+`/cc/campaigns/pause/`+selectedCampaign+`/`+breakPk+`/`,{}, this.config)
    }
    unpauseCampaign(selectedCampaign){
        return axios.delete(API_URL+`/cc/campaigns/unpause/`+selectedCampaign, this.config)
    }

    dial(selectedCampaign, in_telNumber, in_uuid, in_cpk, in_rpk){
        //console.log(in_telNumber)
        //console.log(in_uuid)
        return axios.put(API_URL+`/cc/campaigns/dial/`+selectedCampaign,
            {
                    telNumber:in_telNumber,
                    uuid:in_uuid,
                    cPk:in_cpk,
                    rPk:in_rpk
            },
            this.config)
    }

    findResultList(selectedCampaign){
        return axios.get(API_URL+`/cc/campaigns/result/`+selectedCampaign, this.config)
    }

    saveResult(selectedCampaign, in_rPk, in_resultCode, in_note, in_uuid, in_callback_date, in_callback_time, in_result_type, in_callback_tel_number){
        return axios.patch(API_URL+`/cc/campaigns/record/`+selectedCampaign,{
            rPk:in_rPk,
            resultCode:in_resultCode,
            resultType:in_result_type,
            telNumber:in_callback_tel_number,
            note:in_note,
            callbackDate: in_callback_date + ' ' + in_callback_time,
            lastUser:'',
            uuid:in_uuid
        }, this.config)
    }



    getAgentLeads(in_from, in_to){
        return axios.post(API_URL+`/order/getagentleads`,{
            "from":in_from,
            "to" : in_to
        },this.config)
    }

    getNewOrderByProjectAmount() {
        return axios.get(API_URL+`/order/aggleads/`+localStorage.getItem("defaultOrganization"),this.config)
    }

    getProjectList() {
        return axios.get(API_URL+`/order/projectlist/`+localStorage.getItem("defaultOrganization"),this.config)
    }
    getProjectListFull() {
        return axios.get(API_URL+`/order/projectlistFull/`+localStorage.getItem("defaultOrganization"),this.config)
    }

    saveTargetAll(in_day_target, in_month_target){
        return axios.post(API_URL+`/order/savetargetall`,{
            "day":in_day_target,
            "month" : in_month_target
        },this.config)
    }

    getTargetAll() {
        return axios.get(API_URL+`/order/gettargetall`,this.config)
    }

    getLeadsAmountInMonth() {
        return axios.get(API_URL+`/order/getleadsamountinmonth`,this.config)
    }

    findNextCallbackList(pk) {
        return axios.get(API_URL+`/cc/campaigns/getcallbacklist/`+pk,this.config)
    }

    saveAgent(param) {
        return axios.post(API_URL+`/cc/user/add/`,param,this.config)
    }

    changePassword(param) {
        return axios.post(API_URL+`/cc/user/pass/`,param,this.config)
    }

    getCurrentUserData() {
        return axios.get(API_URL+`/cc/user/data/`,this.config)
    }

    getUserDataByPk(userPk) {
        let filter ={
            userPk:userPk,
            orPk:localStorage.getItem("defaultOrganization"),
        }
        return axios.post(API_URL+`/cc/user/data/`,filter, this.config)
    }

    uploadAvatar(formData) {
        axios.post(API_URL+`/cc/user/avatar/`,formData,this.config)
    }

    uploadCV(formData) {
        return axios.post(API_URL+`/cc/user/cv/`,formData,this.config)
    }

    addNewCV(param) {
        return axios.put(API_URL+`/cc/user/cv/`,param,this.config)
    }

    getApplicantSrcList() {
        let filter ={
            "orPk": localStorage.getItem("defaultOrganization"),
        }

        return axios.post(API_URL+`/cc/user/applicantsrclist/`,filter,this.config)
    }

    getCampaignList() {
        let filter ={
            "orPk": localStorage.getItem("defaultOrganization"),
            "status":1,
        }
        return axios.post(API_URL+`/cc/campaigns/`,filter, this.config)
    }

    getSphChartData() {
        return axios.get(API_URL+`/order/getSphChart/`,this.config)
    }

    getAgentOrderStatisticByDate(daysMinus, orderBy, orderType, date) {
        return axios.post(API_URL+`/order/getAgentOrderStatisticByDate/`, {date:date, daysMinus:daysMinus, orderBy:orderBy, orderType:orderType, orPk:localStorage.getItem("defaultOrganization")}, this.config)
    }

    createCampaign(pk, name){
        return axios.post(API_URL+`/cc/campaign/`,{
            cpk:pk,
            name:name,
            orPk:localStorage.getItem("defaultOrganization"),
        }, this.config)
    }

    createCampaignV2(pk, name, mode){
        return axios.post(API_URL+`/cc/campaign/create/`,{
            cpk:pk,
            name:name,
            orPk:localStorage.getItem("defaultOrganization"),
            mode: mode,
        }, this.config)
    }

    addOrderBMW(data) {
        return axios.put(`${API_URL}/order/addBMW`, data, this.config)
    }

    getAgentStat(cpk) {
        return axios.get(API_URL+`/cc/campaigns/agentstat/`+cpk,this.config)
    }

    getProjectAgreementByProject(value) {
        return axios.get(API_URL+`/order/getprojectagreement/`+value,this.config)
    }

    getBackOffceChangeStatus(pk, name, note, order) {
        return axios.post(API_URL+`/order/backoffcechangestatus`,{
            pk:pk,
            status:name,
            back_office_note:note,
            order:order
        }, this.config)
    }

    getLeadDetails(pk) {
        return axios.post(API_URL+`/order/leaddetails`, {
            pk:pk
        }, this.config)
    }

    getLeadDetailsWithForm(pk) {
        let filters = {
            "pk":pk,
        }

        return axios.post(API_URL+`/order/leaddetailswithform`, filters, this.config)
    }

    findAllRecordsByTelNumbers(tel_number, tel_number_record) {
        return axios.post(API_URL+`/cc/campaigns/91/findrecordsbytelnumbers`, {
            numbers:[
                tel_number,
                tel_number_record
            ]
        }, this.config)
    }

    //DEPRECATED
    getFieldsByProject(prPk) {
        return axios.get(API_URL+`/order/getprojectfields/`+prPk,this.config)
    }

    getFieldsByProject(prPk) {
        let data={
            prPk:prPk,
        }
        return axios.post(API_URL+`/order/project/fields/`,data,this.config)
    }



    saveTargetByProject(prPk, dayTarget, monthTarget, wkValue, wkType) {
        return axios.post(API_URL+`/order/settarget/`+prPk,{dayTarget:dayTarget, monthTarget:monthTarget, wk:wkValue, wkType:wkType}, this.config)
    }

    getApplicantsByStatus(applicantStatus, dateFrom, dateTo, src) {
        let filter = {
            status:applicantStatus,
            dateFrom:dateFrom,
            dateTo:dateTo,
            orPk:localStorage.getItem("defaultOrganization"),
            src:src,
        }
        return axios.post(API_URL+`/cc/user/applicantsbystatus`,filter, this.config)
    }



    findApplicantHistory(pk) {
        return axios.get(API_URL+`/cc/user/applicanthistory/`+pk,this.config)
    }

    updateApplicantStatus(status, note, callback_date, callback_time, rcpk) {
        return axios.post(API_URL+`/cc/user/updateapplicantstatus`,{
            "status":status,
            "note" : note,
            "callbackDate": callback_date,
            "callbackTime": callback_time,
            "rcpk": rcpk
        },this.config)
    }

    findLeadKS(filters) {
        return axios.post(API_URL+`/order/report/findLeadKS`,filters, this.config)
    }

    getWorkers(filters) {
        return axios.post(API_URL+`/cc/user/getworkers`,filters, this.config)
    }

    updateWorker(currentWorker) {
        return axios.post(API_URL+`/cc/user/update`,currentWorker, this.config)
    }

    updateUserSettingsV2(formData) {
        return axios.post(API_URL+`/cc/user/updatesetting`,formData,this.config)
    }

    getMonitoring(filters) {
        return axios.post(API_URL+`/cc/monitoring/get`,filters, this.config)
    }

    saveTime(object) {
        return axios.post(API_URL+`/cc/monitoring/savetime`, object, this.config)
    }

    getWalletData(month) {
        let obj ={
            month:month
        }
        return axios.post(API_URL+`/order/wallet/get`, obj, this.config)
    }

    checkUsedProjectsByTelNumber(number) {
        let object = {
            tel_number:number
        }

        return axios.post(API_URL+`/order/usedprojectsbytelnumber`, object, this.config)
    }

    getNavigations() {
        return axios.get(API_URL+`/navigation/modules`,this.config)
        //axios.get(`https://api.invosystem.com/navigation/modules`,this.config)
    }

    saveNewProject(newProjectName, newProjectWk, newProjectPrice, newProjectAccountManager, newProjectStatus) {

        let obj={
            newProjectName:newProjectName,
            newProjectWk:newProjectWk,
            newProjectPrice:newProjectPrice,
            newProjectAccountManager:newProjectAccountManager,
            newProjectStatus:newProjectStatus,
            orPk:localStorage.getItem("defaultOrganization"),
        }

        return axios.post(API_URL+`/order/project/new`, obj, this.config)
    }

    getOrdersFields() {
        return axios.get(API_URL+`/order/fields`,this.config)
    }

    getCurrentFieldsOfForms(projectPk) {
        return axios.get(API_URL+`/order/formFields/`+projectPk,this.config)
    }

    updateFormFields(projectPk, currentFields) {
        return axios.post(API_URL+`/order/formFields/update/`+projectPk, currentFields, this.config)
    }

    getAggregateFieldsList() {
        return axios.get(API_URL+`/order/fields`,this.config)
    }

    findOrderReport(filters) {
        return axios.post(API_URL+`/order/report/`, filters, this.config)
    }

    getTeamList() {
        return axios.get(API_URL+`/cc/team/`+localStorage.getItem("defaultOrganization"),this.config)
    }

    getTeamListByOrg(org) {
        return axios.get(API_URL+`/cc/team/`+org,this.config)
    }

    getAgentsForCampaign(cpk) {
        return axios.get(API_URL+`/cc/usersincampaign/`+cpk,this.config)
    }

    addAgentsToCampaign(currentagent, currentCpk) {
        let data={
            agent:currentagent,
            cpk:currentCpk,
        }
        return axios.post(API_URL+`/cc/addusertocampaign/`, data, this.config)
    }

    removeAgentFromCampaign(agent, cpk) {
        let data={
            agent:agent,
            cpk:cpk,
        }
        return axios.post(API_URL+`/cc/removeAgentFromCampaign/`, data, this.config)
    }

    resetPassword(data) {
        return axios.post(API_URL+`/cc/user/resetpassword`,data, this.config)
    }

    getCampaignSettings(cpk) {
        let data={
            cpk:cpk,
        }
        return axios.post(API_URL+`/cc/campaign/settings`,data, this.config)
    }

    googleCredentials(formData) {
        return axios.post(API_URL+`/cc/campaign/googlecredentials/`,formData,this.config)
    }

    getExcludeWorkTime(cpk) {
        let data={
            cpk:cpk
        }
        return axios.post(API_URL+`/cc/campaign/excludedates/`,data,this.config)
    }
    getWorkTime(cpk) {
        let data={
            cpk:cpk
        }
        return axios.post(API_URL+`/cc/campaign/availability/`,data,this.config)
    }

    saveAvailableWorkTime(workTimeData) {
        return axios.post(API_URL+`/cc/campaign/saveavailability/`,workTimeData,this.config)
    }

    saveExcludeDates(excludedates, cpk) {
        let data ={
            cpk:cpk,
            excludeDates:excludedates
        }
        return axios.post(API_URL+`/cc/campaign/saveexcludedates/`+91,excludedates,this.config)
    }

    saveSettings(date) {
        return axios.put(API_URL+`/cc/campaign/settings`,date,this.config)
    }

    updateEmployee(data) {
        return axios.put(API_URL+`/cc/user/setting`, data, this.config)
    }

    getDocumentsByUser() {
        let data ={
            "orPk":localStorage.getItem("defaultOrganization")
        }
        return axios.post(API_URL+`/cc/documents`,data,this.config)
    }

    sendPasswordToDocument(pk) {
        let data ={
            pk:pk,
        }
        return axios.put(API_URL+`/cc/document/sendPass`,data,this.config)
    }

    signDocument(pk) {
        let data ={
            "docPk":pk
        }
        return axios.post(API_URL+`/cc/document/sign`,data,this.config)
    }

    downloadDocument(pk) {
        return axios({
            url: API_URL+`/cc/document/get/`+pk,
            method: 'GET',
            responseType: 'blob', // important
            headers: {
                authorization: localStorage.getItem("token"),
            }
        })
    }

    downloadSalaryList(filters) {
        return axios({
            url: API_URL+`/cc/salarylist/get`,
            method: 'POST',
            data: filters,
            responseType: 'blob', // important
            headers: {
                authorization: localStorage.getItem("token"),
            }
        })
    }

    downloadDocumentAdmin(pk) {
        return axios({
            url: API_URL+`/cc/document/geta/`+pk,
            method: 'GET',
            responseType: 'blob', // important
            headers: {
                authorization: localStorage.getItem("token"),
            }
        })
    }

    downloadCVPDF(fileName) {
        return axios({
            url: API_URL+`/cc/user/downloadCVPdf/`+fileName,
            method: 'GET',
            responseType: 'blob', // important
            headers: {
                authorization: localStorage.getItem("token"),
            }
        })
    }

    downloadWav(fileName) {
        console.log(API_URL+`/order/audio/`+fileName)
        return axios({
            url: API_URL+`/order/audio/`+fileName,
            method: 'GET',
            responseType: 'blob', // important
            headers: {
                authorization: localStorage.getItem("token"),
            }
        })
    }


    signDocumentGeneratePIN(pk) {
        let data ={
            "docPk":pk
        }
        return axios.post(API_URL+`/cc/document/generatePin`,data,this.config)
    }

    signDocumentByPIN(docPk, pin) {
        let data ={
            "docPk":docPk,
            "pin":pin,
        }
        return axios.post(API_URL+`/cc/document/signByPIN`,data,this.config)
    }

    updateStatement(fieldName, value, userPk) {
        let data ={
            "userPk":userPk,
            "fieldName":fieldName,
            "value":value,
        }
        return axios.put(API_URL+`/cc/user/statement/update`,data,this.config)
    }

    softphoneStart(email) {
        let data ={
            "email":email,
        }
        return axios.put(API_URL+`/cc/user/softphoneaccount`,data,this.config)
    }

    checkIBANNumber(value) {
        let data ={
            "iban":value,
        }
        return axios.post(API_URL+`/cc/utils/iban`,data,this.config)
    }

    addDocumentToUser(data) {
        let data1 ={
            "data":data,
            "organizationPk":localStorage.getItem("defaultOrganization"),
        }
        return axios.post(API_URL+`/cc/user/adddocumentfromtemplate`,data1,this.config)
    }

    getTemplateParams(templateId) {
        let data ={
            "templateId":templateId,
        }
        return axios.post(API_URL+`/cc/document/template/params`,data,this.config)
    }

    findSrcFields(filters) {
        return axios.post(API_URL+`/cc/document/template/srcfields`,filters,this.config)
    }

    getCurrentDbState(filters) {
        return axios.post(API_URL+`/cc/campaign/db/currentstate`,filters,this.config)
    }

    uploadImportDbFile(formData) {
        return axios.post(API_URL+`/cc/campaign/db/file`,formData,this.config)
    }

    importDbFile(filters) {
        return axios.post(API_URL+`/cc/campaign/db/import`,filters,this.config)
    }

    beginFreshRecords(filters) {
        return axios.post(API_URL+`/cc/campaign/db/fresh`,filters,this.config)
    }

    resultConfigProperties(currentCpk, resultCode) {
        let data ={
            "orPk":localStorage.getItem("defaultOrganization"),
            "cpk":currentCpk,
            "rspk":resultCode,
        }
        return axios.post(API_URL+`/cc/campaign/resultconfigproperties/`,data,this.config)
    }

    addUpdateResult(data) {
        return axios.put(API_URL+`/cc/campaign/resultconfigproperties/`,data,this.config)
    }

    getDocumentTemplatesListByOrganization(filters) {
        return axios.post(API_URL+`/cc/document/template/list`,filters,this.config)
    }

    getDocumentsByUserByType(userPk, documentType) {
        let data ={
            "orPk":localStorage.getItem("defaultOrganization"),
            "userPk":userPk,
            "documentType":documentType,
        }
        return axios.post(API_URL+`/cc/documents/bytype`,data,this.config)
    }

    getRecruitsFieldById(pk) {
        let data ={
            "orPk":localStorage.getItem("defaultOrganization"),
            "recPk":pk,
        }
        return axios.post(API_URL+`/cc/recruitsfields`,data,this.config)
    }


    addNewCVV2(formData) {
        return axios.put(API_URL+`/cc/user/cv/`,formData,this.config)
    }

    findCrmRecordByQuery(filters) {
        return axios.post(API_URL+`/order/find/`, filters, this.config)
    }

    findRecruitsForm(filters) {
        return axios.post(API_URL+`/cc/recruits/formslist/`,filters,this.config)
    }



    uploadDocumentTemplateFile(formData) {
        return axios.post(API_URL+`/cc/documents/template/file`,formData,this.config)
    }

    saveNewDocumentTemplate(formData) {
        return axios.put(API_URL+`/cc/document/template/add`,formData,this.config)
    }

    changeDocumentTemplateStatus(filters) {
        return axios.post(API_URL+`/cc/document/template/status`,filters,this.config)
    }


    getTagList(value, currentCpk) {
        let filters ={
            "tag":value,
            "cpk":currentCpk,
        }

        return axios.post(API_URL+`/cc/campaign/taglist`,filters,this.config)
    }

    beginMoveRecords(data) {
        return axios.post(API_URL+`/cc/campaign/moverecords`,data,this.config)
    }

    findImportsByOrg(data) {
        return axios.post(API_URL+`/cc/campaign/db/importlist`,data,this.config)
    }

    findAdditionalColumns(currentCpk) {
        let filters ={
            "cpk":currentCpk,
        }

        return axios.post(API_URL+`/cc/campaign/additionalcolumns`,filters,this.config)
    }

    //findImportsByOrg(orPk) {
    //    let filters ={
    //        "orPk":orPk,
    //    }

    //    return axios.post(API_URL+`/cc/campaign/importlist`,filters,this.config)
    //}

    findReportSalary(filters) {
        return axios.post(API_URL+'/cc/user/salaryreport/',filters, this.config)
    }

    confirmLead(currentLead, backOfficeNote, projectName) {
        let data ={
            currentLead: currentLead,
            backOfficeNote: backOfficeNote,
            projectName:projectName,
        }

        //console.log(currentLead)
        return axios.post(API_URL+'/order/confirmlead',data, this.config)
    }

    cancelLead(currentLead, backOfficeNote, projectName) {
        let data ={
            currentLead: currentLead,
            backOfficeNote: backOfficeNote,
            projectName:projectName,
        }

        //console.log(currentLead)
        return axios.post(API_URL+'/order/cancellead',data, this.config)
    }

    getRecruitsFieldDesc() {
        let data ={
            orPk:Number(localStorage.getItem("defaultOrganization")),
        }

        return axios.post(API_URL+`/cc/recruitsfieldsdesc`, data, this.config)
    }

    saveEditRecruitsForm(data) {
        return axios.post(API_URL+`/cc/recruitsformsaveedit`, data, this.config)
    }

    findRecruitsFormByPk(pk) {
        let filters = {
            pk:pk,
            orPk:Number(localStorage.getItem("defaultOrganization")),
        }

        return axios.post(API_URL+`/cc/recruits/recruitsformbypk/`,filters,this.config)
    }

    findScriptsByCmpPk(data) {
        return axios.post(API_URL+`/cc/scripts/`,data,this.config)
    }

    enableDisableRecruitsForm(data) {
        return axios.post(API_URL+`/cc/recruits/recruitsformenableddisabled/`,data,this.config)
    }

    enableDisableProject(prPk, value) {
        return axios.post(API_URL+`/order/enabledisableproject/`+prPk,{status:value}, this.config)
    }

    enableDisableArchivProject(prPk, value) {
        return axios.post(API_URL+`/order/enabledisablearchivproject/`+prPk,{status:value}, this.config)
    }
}

export default new APIService()
